import { collection, query, where, getDocs, addDoc, setDoc, doc } from "firebase/firestore";
import { getUsersByUID, updateUser } from './userService';
import { db } from '../firebase';
import { CORRECTRESULTSCORES, CORRECTRESULT, CORRECTFINAL8, CORRECTFINAL4, CORRECTFINAL, 
    CORRECTFINAL8TEAM, CORRECTFINAL4TEAM, CORRECTFINALTEAM, CORRECTQUESTIONNAIRE } from '../assets/configs/constants'

async function getPredictionByUID(uid) {

    const q = query(collection(db, "predictions"), where("uid", "==", uid));
    const querySnapshot = await getDocs(q);
    let p = null, err = null;
    querySnapshot.forEach((doc) => {
        if(!Boolean(p)) {
            p = doc.data();
        } else {
            err = 'Multiple predictions found with the same UID';
        }
    });

    return new Promise((resolve, reject) => {
        if(Boolean(err)) { reject(err); } // error, e.g. multiple predictions found
        else if(!Boolean(p)) { resolve(null); }  // ok, but no prediction found
        else { resolve(p); } // ok, return prediction
    });
}

async function getPredictionAnswer() {

    const q = query(collection(db, "predictions"), where("uid", "==", "hyPRV6TXakMbalAtyb33uDFsOJb2"));
    const querySnapshot = await getDocs(q);
    let p = null, err = null;
    querySnapshot.forEach((doc) => {
        if(!Boolean(p)) {
            p = doc.data();
        } else {
            err = 'Multiple predictions found with the same UID';
        }
    });

    return new Promise((resolve, reject) => {
        if(Boolean(err)) { reject(err); } // error, e.g. multiple predictions found
        else if(!Boolean(p)) { resolve(null); }  // ok, but no prediction found
        else { resolve(p); } // ok, return prediction
    });
}

async function updatePrediction(newP) {

    const q = query(collection(db, "predictions"), where("uid", "==", newP.uid));
    const querySnapshot = await getDocs(q);
    let docid = null, err = null;
    querySnapshot.forEach((doc) => {
        if(!Boolean(docid)) {
            docid = doc.id
        } else {
            err = 'Multiple predictions found with the same UID';
        }
    });

    return new Promise((resolve, reject) => {
        if(err) { reject(err) }
        if(Boolean(docid)) { // Doc ID exists - update prediction

            const docRef = doc(db, "predictions", docid);
            setDoc(docRef, newP, { merge: true})        
            .then((p) => resolve(p))
            .catch((e) => reject(e));
        } else { // Doc ID does not exist - create prediction
            addDoc(collection(db, "predictions"), newP)
            .then((p) => { resolve(p); })
            .catch((e) => reject(e));
        }
    });
}

async function predictionReview() {

    return new Promise((resolve, reject) => {
        let predAnswerArray = []
        getPredictionAnswer() // get predictionAnswers
        .then((pa) => {
            predAnswerArray = pa.prediction
            let final8Predictions = [], final4Predictions = [], finalPredictions = []
            // Fill the final8 predictions array
            predAnswerArray.filter((paa) => paa.stage === "final8").forEach((paa) => {
                if(Boolean(paa.awayTeamID)){ final8Predictions.push(paa.awayTeamID) }
                if(Boolean(paa.homeTeamID)){ final8Predictions.push(paa.homeTeamID) }
            })
            // Fill the final4 predictions array
            predAnswerArray.filter((paa) => paa.stage === "final4").forEach((paa) => {
                console.log("paa", paa, paa.matchid, paa.awayTeamID, paa.homeTeamID)
                if(Boolean(paa.awayTeamID)){ final4Predictions.push(paa.awayTeamID) }
                if(Boolean(paa.homeTeamID)){ final4Predictions.push(paa.homeTeamID) }
            })
            // Fill the final predictions array
            predAnswerArray.filter((paa) => paa.stage === "final1").forEach((paa) => {
                if(Boolean(paa.awayTeamID)){ finalPredictions.push(paa.awayTeamID) }
                if(Boolean(paa.homeTeamID)){ finalPredictions.push(paa.homeTeamID) }
            })

            getUsersByUID('any') // get all users (except prediction answers)
            .then((allusers) => {
                allusers.forEach((u, i) => { // Loop through each user
                    getPredictionByUID(u.uid) // get predictions for that users
                    .then((p) => {
                        let userPredictions = p.prediction;

                        // Check all of the group stage predictions
                        predAnswerArray
                        .filter((paa) => paa.stage === "group")
                        .forEach((paa) => { // loop through each prediction that is in the answer sheet

                            let idx = userPredictions.findIndex((up) => up.matchid === paa.matchid)

                            // Only review if the pts for this prediction answer is not yet assigned
                            if(Boolean(userPredictions[idx]) && isNaN(userPredictions[idx].pts)){

                                let uppts = 0;
                                // review user prediction against answer sheet

                                if( // User answer matches result & scores
                                userPredictions[idx].home !== undefined && userPredictions[idx].home !== null && userPredictions[idx].home !== '' && 
                                userPredictions[idx].away !== undefined && userPredictions[idx].away !== null && userPredictions[idx].away !== '' && 
                                userPredictions[idx].home === paa.home &&
                                userPredictions[idx].away === paa.away){

                                    uppts = CORRECTRESULTSCORES;

                                } else if ( // User answer matches result but not score
                                userPredictions[idx].home !== undefined && userPredictions[idx].home !== null && userPredictions[idx].home !== '' && 
                                userPredictions[idx].away !== undefined && userPredictions[idx].away !== null && userPredictions[idx].away !== '' && 
                                (   // Agreed that home wins
                                    (userPredictions[idx].home > userPredictions[idx].away && paa.home > paa.away)
                                    || 
                                    // Agreed that away wins
                                    (userPredictions[idx].home < userPredictions[idx].away && paa.home < paa.away)
                                    ||
                                    // Agreed that it's equal
                                    (userPredictions[idx].home === userPredictions[idx].away && paa.home === paa.away)
                                )){

                                    uppts = CORRECTRESULT;

                                } // Otherwise user answer does not match result or score

                                userPredictions[idx].pts = uppts; // update the user prediction record
                            }
                        }) // End of the group prediction answer loop

                        // todo - optimize review - no need to loop through all of the predictions again

                        // Check all of the knockout stage predictions
                        // final8
                        userPredictions.filter((up) => up.stage === "final8").forEach((up) => {
                            let idx = userPredictions.findIndex((ups) => ups.matchid === up.matchid)
                            if(final8Predictions.includes(up.homeTeamID) &&                             
                            predAnswerArray.some((paa) => paa.matchid === up.matchid && paa.homeTeamID === up.homeTeamID)){
                                userPredictions[idx].ptsh = CORRECTFINAL8;
                            } else if(final8Predictions.includes(up.homeTeamID)){
                                userPredictions[idx].ptsh = CORRECTFINAL8TEAM; 
                            } else if(final8Predictions.length === 8){
                                userPredictions[idx].ptsh = 0;
                            }
                            if(final8Predictions.includes(up.awayTeamID) &&
                            predAnswerArray.some((paa) => paa.matchid === up.matchid && paa.awayTeamID === up.awayTeamID)){
                                userPredictions[idx].ptsa = CORRECTFINAL8;
                            } else if(final8Predictions.includes(up.awayTeamID)){
                                userPredictions[idx].ptsa = CORRECTFINAL8TEAM;
                            } else if(final8Predictions.length === 8){
                                userPredictions[idx].ptsa = 0;
                            }
                        })

                        // final4
                        userPredictions.filter((up) => up.stage === "final4").forEach((up) => {
                            let idx = userPredictions.findIndex((ups) => ups.matchid === up.matchid)
                            if(final4Predictions.includes(up.homeTeamID) &&                             
                            predAnswerArray.some((paa) => paa.matchid === up.matchid && paa.homeTeamID === up.homeTeamID)){
                                userPredictions[idx].ptsh = CORRECTFINAL4;
                            } else if(final4Predictions.includes(up.homeTeamID)){
                                userPredictions[idx].ptsh = CORRECTFINAL4TEAM;
                            } else if(final4Predictions.length === 4 || 
                                (final8Predictions.length === 8 && !final8Predictions.includes(up.homeTeamID))){
                                userPredictions[idx].ptsh = 0;
                            }
                            if(final4Predictions.includes(up.awayTeamID) &&
                            predAnswerArray.some((paa) => paa.matchid === up.matchid && paa.awayTeamID === up.awayTeamID)){
                                userPredictions[idx].ptsa = CORRECTFINAL4;
                            } else if(final4Predictions.includes(up.awayTeamID)){
                                userPredictions[idx].ptsa = CORRECTFINAL4TEAM;
                            } else if(final4Predictions.length === 4 || 
                                (final8Predictions.length === 8 && !final8Predictions.includes(up.awayTeamID))){
                                userPredictions[idx].ptsa = 0;
                            }
                        })

                        // final
                        userPredictions.filter((up) => up.stage === "final1").forEach((up) => {
                            let idx = userPredictions.findIndex((ups) => ups.matchid === up.matchid)
                            if(finalPredictions.includes(up.homeTeamID) &&
                            predAnswerArray.some((paa) => paa.matchid === up.matchid && paa.homeTeamID === up.homeTeamID)){
                                userPredictions[idx].ptsh = CORRECTFINAL;
                            } else if(finalPredictions.includes(up.homeTeamID)){
                                userPredictions[idx].ptsh = CORRECTFINALTEAM;
                            } else if(finalPredictions.length === 2 || 
                                (final4Predictions.length === 4 && !final4Predictions.includes(up.homeTeamID)) ||
                                (final8Predictions.length === 8 && !final8Predictions.includes(up.homeTeamID))){
                                userPredictions[idx].ptsh = 0;
                            }
                            if(finalPredictions.includes(up.awayTeamID) &&
                            predAnswerArray.some((paa) => paa.matchid === up.matchid && paa.awayTeamID === up.awayTeamID)){
                                userPredictions[idx].ptsa = CORRECTFINAL;
                            } else if(finalPredictions.includes(up.awayTeamID)){
                                userPredictions[idx].ptsa = CORRECTFINALTEAM;
                            } else if(finalPredictions.length === 2 || 
                                (final4Predictions.length === 4 && !final4Predictions.includes(up.awayTeamID)) ||
                                (final8Predictions.length === 8 && !final8Predictions.includes(up.awayTeamID))){ 
                                userPredictions[idx].ptsa = 0;
                            }
                        })
                        // end of knockout prediction answer loop

                        // start of questionnaire prediction answer loop
                        predAnswerArray
                        .filter((paa) => paa.stage === "questionnaire")
                        .forEach((paa) => { 
                            let idx = userPredictions.findIndex((ups) => ups.stage === "questionnaire" && ups.qid === paa.qid)

                            //console.log("paa", paa, userPredictions[idx])
                            //console.log("paa1",idx > -1, paa.answer.includes(userPredictions[idx].answer))
                            //console.log("paa2", paa.answer, userPredictions[idx].answer)

                            if(idx > -1 && paa.answer.includes(userPredictions[idx].answer)){
                                userPredictions[idx].pts = CORRECTQUESTIONNAIRE;
                            } else if(idx > -1){
                                userPredictions[idx].pts = 0;
                            }
                        })
                        // end of questionnaire prediction answer loop

                        // once reviewed successfully, update the prediction record for that user
                        updatePrediction({uid: u.uid, prediction: userPredictions})
                        .then((upsuc) => {
                            
                            // Also update the total pts for that user record
                            let userpts = 0;
                            userPredictions.forEach((userpred) => {
                                if(!isNaN(userpred.pts)){
                                    userpts = userpts + userpred.pts;
                                } else if(!isNaN(userpred.ptsh)){
                                    userpts = userpts + userpred.ptsh;
                                } else if(!isNaN(userpred.ptsa)){
                                    userpts = userpts + userpred.ptsa;
                                }
                            })
                            let newUserRecord = u;
                            newUserRecord.pts = userpts;
                            updateUser(newUserRecord)
                            .then((nu) => {

                                if(allusers.length === i + 1) { // all users are updated, respond and resolve

                                    resolve("Review success");

                                }
                            }).catch((uperr) => { reject("err5", uperr)})
                        }).catch((uperr) => { reject("err4", uperr)})
                    }).catch((err) => { console.log("err3", err) ;reject("err3", err) })
                }) // end of the per user loop
            }).catch((err) => reject("err2", err))
        }).catch((err) => reject("err1", err))
    })

}

export {
    getPredictionAnswer,
    getPredictionByUID,
    predictionReview,
    updatePrediction
}